import { useStoreActions } from "../../store/store-context";
import { PracticeManagement } from "../../types/api.model";
import PMSetupPage from "./PMSetupPage/PMSetupPage";
import { jsx as _jsx } from "react/jsx-runtime";
export const KarbonSetupPage = _ref => {
  let {
    integration
  } = _ref;
  const {
    api,
    fetchKarbonItems
  } = useStoreActions();
  return /*#__PURE__*/_jsx(PMSetupPage, {
    testid: "karbon-setup",
    pmName: PracticeManagement.Karbon,
    integration: integration,
    getItems: fetchKarbonItems,
    doDisconnect: api.karbon.disconnect,
    linkServiceTemplate: api.karbon.linkServiceTemplate,
    getServiceTemplateIntegratedIds: template => template.integrations.karbonIntegratedIds()
  });
};